import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Layout from './Layout';
import Home from './Pages/Home';
import References from './Pages/References.js';
import LogIn from './Components/Auth/Login.js'
import AdminLogin from './Components/Auth/AdminLogin.js'
import Maintenance from './Pages/Maintenance.js'
import EditPage from './Pages/EditPage.js'
import Retail from './Pages/Retail.js'
import Contact from "./Pages/Contact.js";
import About from "./Pages/About.js";
import Products from "./Pages/Products.js";
import DetailedProduct from "./Pages/DetailedProduct.js";
import Tests from "./Pages/Tests.js";
import Reports from "./Pages/Reports.js";
import DetailedReference from "./Pages/DetailedReference.js";
import Sheets from "./Pages/Sheets.js"
import Expertise from "./Pages/Expertise.js"
import apiUrl from "./Components/Helpers/APIWrapper.js";
import { ProtectedRoute } from "./Components/Helpers/ProtectedRoute.js";

import "react-quill/dist/quill.snow.css";
import './Styles/EditPages.css';
import './Styles/App.css';
import './Styles/Nav.css';
import './Styles/Pages.css'


const App = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    // Check if site is in maintenance mode
    const checkMaintenanceMode = async () => {
      try {
        const response = await axios.get(`${apiUrl}/auth/check-auth`, {
          withCredentials: true
        });
        // If we get a 200, user is authenticated - not in maintenance
        //setIsMaintenanceMode(false);
      } catch (error) {
        console.log("Auth check error:", error);
        //setIsMaintenanceMode(true);
      } finally {
        setIsChecking(false);
      }
    };

    checkMaintenanceMode();
  }, []);

  if (isChecking) {
    return null; // Or a loading spinner
  }
  // If in maintenance mode, only show admin login or maintenance page
  if (isMaintenanceMode) {
    return (
      <Router>
        <Routes>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="*" element={<Maintenance />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Standalone admin login route (no Layout) */}
        <Route path="/admin" element={<AdminLogin />} />
        
        {/* Standalone maintenance page (no Layout) */}
        <Route path="/maintenance" element={<Maintenance />} />
        
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/references" element={<References />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/editpage" element={<ProtectedRoute><EditPage /></ProtectedRoute>} />
          <Route path="/tests" element={<Tests />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/products/*" element={<DetailedProduct />} />
          <Route path="/references/*" element={<DetailedReference />} />
          <Route path="/sheets" element={<Sheets />} />
          <Route path="/expertise/*" element={<Expertise />} />
          <Route path="*" element={<Home/>} />
        </Route>
      </Routes>
    </Router>
  )
};

export default App;
